/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartialPaymentDto } from '../../models/partial-payment-dto';

export interface CreatePartialPayment$Params {
      body: PartialPaymentDto
}

export function createPartialPayment(http: HttpClient, rootUrl: string, params: CreatePartialPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<PartialPaymentDto>> {
  const rb = new RequestBuilder(rootUrl, createPartialPayment.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartialPaymentDto>;
    })
  );
}

createPartialPayment.PATH = '/partialpayments';
